import type { ReactNode } from "react";

import { cn } from "./lib/cn";

export interface KpiStripItem {
  /** Kararlı kimlik — React anahtarı. */
  key: string;
  icon: ReactNode;
  value: ReactNode;
  label: string;
}

export interface KpiStripProps {
  items: readonly KpiStripItem[];
  className?: string;
}

/**
 * Kompakt sayaç şeridi — mockup Ana Sayfa "Güncel Özet" kartının İÇİNDE 3'lü sıra.
 *
 * `StatTile`'ın küçük hâli: kendi kartını taşımaz (çağıran bir `Card`/`SectionCard`
 * içine koyar), ikon kutusu 40px, sayı 22/700 — `StatTile`'ın 56px/24px'inden daha sıkı.
 */
export function KpiStrip({ items, className }: KpiStripProps) {
  return (
    <div className={cn("grid grid-cols-3 gap-3", className)}>
      {items.map((item) => (
        /* ⚠ `key` bir test kancası olarak da dışa veriliyor: aynı etiket ("Bekleyen
           İşlemler") sayfada birden çok yerde geçebiliyor ve sayaç değerini metinle
           hedeflemek yanlış düğümü yakalıyordu. */
        <div
          key={item.key}
          data-testid={`kpi-${item.key}`}
          className="flex flex-col items-start gap-2"
        >
          <span
            aria-hidden="true"
            className="flex size-10 items-center justify-center rounded-lg bg-primary-soft text-primary [&_svg]:size-5"
          >
            {item.icon}
          </span>
          <div className="min-w-0">
            <p className="text-[22px] leading-7 font-bold text-fg-strong tabular-nums">
              {item.value}
            </p>
            <p className="truncate text-xs text-fg-muted">{item.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
